import { useSelector } from "react-redux";

import "@mui/material";
import { Dialog, DialogContent, Box, Card, CardContent } from "@mui/material";

import { LineSkeleton } from "components/formFields/LineSkeleton";
import { CardHeader } from "components/formFields/formCards/CardHeader";
import { FormErrors } from "components/utility/FormErrors";
import { Loading } from "components/utility/Loading";

import { i18n } from "services/i18nService";
import { formatCompanyInfo } from "services/utility/formatting";

import { useErrors } from "hooks/useErrors";

import { ConfirmationModalHeader } from "views/UpsShipments/UpsShipment/Confirmation/Header";
import { UpsTrademark } from "views/UpsShipments/UpsShipment/UpsTrademark";

export function ConfirmationDialog(props) {
  const { record, onClose, rates } = props;

  const { errors, setErrors } = useErrors();

  const rate = rates.find(
    ({ serviceCode, saturdayDelivery }) =>
      serviceCode === record.serviceCode &&
      saturdayDelivery === record.saturdayDelivery
  );

  const isLoading = useSelector((state) => state.loading.editModal);

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <ConfirmationModalHeader
        record={record}
        setErrors={setErrors}
        errors={errors}
        handleClose={onClose}
      />
      {isLoading && <Loading />}
      <DialogContent>
        <FormErrors errors={errors} setErrors={setErrors} />
        <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
          <Card variant="outlined" sx={{ mt: 1, mb: 1, width: "50%" }}>
            <CardContent>
              <CardHeader text={i18n("upsShipment.ShipFrom")} />
              <Box sx={{ whiteSpace: "pre-line" }}>
                {formatCompanyInfo(record.fromAddress)}
              </Box>
            </CardContent>
          </Card>
          <Card variant="outlined" sx={{ mt: 1, mb: 1, width: "50%" }}>
            <CardContent>
              <CardHeader text={i18n("upsShipment.ShipTo")} />
              <Box sx={{ whiteSpace: "pre-line" }}>
                {formatCompanyInfo(record.toAddress)}
              </Box>
            </CardContent>
          </Card>
        </Box>
        <Card
          variant="outlined"
          sx={{ marginTop: "1.0em", marginBottom: "1.0em" }}
        >
          <CardContent>
            <CardHeader text={i18n("upsShipment.ShippingDetails")} />
            <ShippingField
              name={i18n("upsShipment.ServiceType")}
              value={rate.name}
            />
            <ShippingField
              name={i18n("upsShipment.EstimatedDelivery")}
              value={rate.estimatedArrival}
            />
            <ShippingField
              name={i18n("upsShipment.TotalCharges")}
              value={`$${rate.cost}`}
            />
            <ShippingField
              name={i18n("upsShipment.BillTo")}
              value={record.upsAccount.name}
            />
          </CardContent>
        </Card>
        <UpsTrademark />
      </DialogContent>
    </Dialog>
  );
}

function ShippingField(props) {
  const { name, value, isLoading } = props;

  return (
    <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
      <div style={{ minWidth: "16ch", fontWeight: "bold", textAlign: "right" }}>
        {name}:
      </div>
      {isLoading ? (
        <LineSkeleton sx={{ flexGrow: 1, maxWidth: "12ch" }} />
      ) : (
        <div style={{ flexGrow: 1 }}>{value}</div>
      )}
    </div>
  );
}
